import { StaffScheduleClient } from './staff-schedule-client';
export default function MySchedulePage() { return <StaffScheduleClient />; }
